import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightText',
  standalone: true,
  pure: true,
})
export class HighlightTextPipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    needle: string | null | undefined,
    cssClass = 'hit',
  ): string {
    const s = (value ?? '').toString();
    const n = (needle ?? '').toString().trim();

    if (!s) return '';
    if (!n) return this.escapeHtml(s);

    const hay = s.toLowerCase();
    const ned = n.toLowerCase();

    let out = '';
    let i = 0;

    while (i < s.length) {
      const j = hay.indexOf(ned, i);
      if (j === -1) break;

      if (j > i) out += this.escapeHtml(s.slice(i, j));

      const k = j + n.length;
      out += `<span class="${this.escapeAttr(cssClass)}">${this.escapeHtml(
        s.slice(j, k),
      )}</span>`;

      i = k;
    }

    if (i < s.length) out += this.escapeHtml(s.slice(i));

    return out || this.escapeHtml(s);
  }

  private escapeHtml(x: string): string {
    return x
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  private escapeAttr(x: string): string {
    return x.replace(/&/g, '&amp;').replace(/"/g, '&quot;');
  }
}
